import React from "react";
import { GatewayNameDropdown } from "@src/components/atoms/gateway-name-dropdown/gateway-name-dropdown";
import { ButtonWithLoader } from "@src/components/atoms/buttons/button-with-loader/button-with-loader";
// import { TextButton } from "@src/components/atoms/buttons/text-button/text-button";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { HelpIconPopover } from "@src/components/atoms/help-icon-popover/help-icon-popover";
import closeIcon from "@src/assets/svg/close-icon.svg";
import { MachineAvailabilityStatusPanel } from "./machine-availability-status/machine-availability-status";
import { useAddNewMachineDrawerModalContext } from "./add-new-machine-drawer-modal-context";
import styles from "./add-new-machine-drawer-modal.module.scss";

const cssClassName = "add-new-machine-drawer-modal";

export const AddNewMachineDetailsStep = () => {
  const {
    texts,
    connectedGatewaysListData,
    selectedGateway,
    onSelectGateway,
    machineName,
    onChangeMachineName,
    ipAddress,
    onChangeIpAddress,
    machineAvailabilityStatus,
    machineSkillsLabel,
    machineAvailabilityError,
    machineOperationFailureDetails,
    hasNoSkillsIdentified,
    hasOpcUaSkill,
    hasAllExpectedMachineSkills,
    showProtocolDetails,
    isConnectDisabled,
    showConnectButton,
    showContinueButton,
    // showFinishWithoutSkillsButton,
    isContinueButtonEnabled,
    // isInstallSkillsLoading,
    areActionsLocked,
    handleShowProtocol,
    handleGetSupport,
    handleConnectClick,
    handleRetry,
    handleContinueToMachineSkills,
    // handleFinishWithoutMachineSkills,
    isGatewayPrefilled,
  } = useAddNewMachineDrawerModalContext();

  return (
    <>
      {isGatewayPrefilled && selectedGateway?.name ? (
        <div className={styles[`${cssClassName}__input-container`]}>
          <label className={styles[`${cssClassName}__label`]}>
            {texts.gatewayLabel}
          </label>
          <p className={styles[`${cssClassName}__prefilled-gateway-name`]}>
            {selectedGateway.name}
          </p>
        </div>
      ) : (
        <GatewayNameDropdown
          options={connectedGatewaysListData}
          selectedGateway={selectedGateway}
          onSelectGateway={onSelectGateway}
          gatewayLabelText={texts.gatewayLabel}
          noGatewaysText={texts.noGatewaysFound}
          placeholderText={texts.gatewayPlaceholder}
          disabled={isGatewayPrefilled || areActionsLocked}
        />
      )}

      <div className={styles[`${cssClassName}__input-container`]}>
        <FlexRowContainer horizontalGap={8} justifyContent="space-between">
          <label
            className={styles[`${cssClassName}__label`]}
            htmlFor="newMachineName"
          >
            {texts.machineNameLabel}
          </label>
          <HelpIconPopover
            helpLabel={texts.help}
            helpText={texts.machineNameHelpText}
          />
        </FlexRowContainer>
        <div className={styles[`${cssClassName}__input-wrapper`]}>
          <input
            id="newMachineName"
            type="text"
            value={machineName}
            disabled={areActionsLocked}
            className={styles[`${cssClassName}__input`]}
            onChange={(e) => onChangeMachineName(e.target.value)}
          />
          {machineName && !areActionsLocked && (
            <button
              type="button"
              className={styles[`${cssClassName}__clear-button`]}
              onClick={() => onChangeMachineName("")}
            >
              <img src={closeIcon} alt="" />
            </button>
          )}
        </div>
      </div>

      <div className={styles[`${cssClassName}__input-container`]}>
        <FlexRowContainer horizontalGap={8} justifyContent="space-between">
          <label
            className={styles[`${cssClassName}__label`]}
            htmlFor="newMachineIpAddress"
          >
            {texts.hostOrIpAddressLabel}
          </label>
          <HelpIconPopover
            helpLabel={texts.help}
            helpText={texts.ipAddressHelpText}
          />
        </FlexRowContainer>
        <div className={styles[`${cssClassName}__input-wrapper`]}>
          <input
            id="newMachineIpAddress"
            type="text"
            value={ipAddress}
            disabled={areActionsLocked}
            className={styles[`${cssClassName}__input`]}
            onChange={(e) => onChangeIpAddress(e.target.value)}
          />
          {ipAddress && !areActionsLocked && (
            <button
              type="button"
              className={styles[`${cssClassName}__clear-button`]}
              onClick={() => onChangeIpAddress("")}
            >
              <img src={closeIcon} alt="" />
            </button>
          )}
        </div>
      </div>

      <MachineAvailabilityStatusPanel
        status={machineAvailabilityStatus}
        skillsLabel={machineSkillsLabel}
        errorMessage={machineAvailabilityError}
        failureDetails={machineOperationFailureDetails}
        showNoSkillsIdentified={hasNoSkillsIdentified}
        showOpcUaNotIdentified={!hasOpcUaSkill}
        showRetryForMissingSkills={!hasAllExpectedMachineSkills}
        showProtocolDetails={showProtocolDetails}
        onShowProtocol={handleShowProtocol}
        onGetSupport={handleGetSupport}
        onRetry={handleRetry}
      />

      {showConnectButton && (
        <ButtonWithLoader
          variant={["full-width", "primary"]}
          fun={handleConnectClick}
          text={texts.connectButton}
          loading={false}
          disabled={isConnectDisabled}
          spinnerVariant={["secondary", "small"]}
        />
      )}

      {showContinueButton && (
        <ButtonWithLoader
          variant={["full-width", "primary"]}
          fun={handleContinueToMachineSkills}
          text={texts.continueMachineSkillsButton}
          loading={false}
          disabled={!isContinueButtonEnabled}
          spinnerVariant={["secondary", "small"]}
        />
      )}

      {/* TODO: Temporary OPC UA compatibility change.
          Re-enable this action once machine onboarding can safely continue without installing OPC UA. */}
      {/* {showFinishWithoutSkillsButton && (
        <div className={styles[`${cssClassName}__secondary-action`]}>
          <TextButton
            clickHandler={handleFinishWithoutMachineSkills}
            text={texts.finishSetupWithoutSkillsButton}
            variant="blue"
            disabled={isInstallSkillsLoading}
          />
        </div>
      )} */}
    </>
  );
};
